import * as NProgress from 'nprogress' // progress bar
import { getToken } from '@/utils/cookie_storage'
import useUserStore from '@/stores/user_stores'

interface IQuery {
  id?: string
  label?: string
}

interface IFrom {
  path: string
}

interface ITo extends IFrom {
  query: IQuery
  name?: string
}

const defaultOptions = {
  whiteList: ['/404', '/login', '/401', '/403', '/intro','/iconpark-test']
}

NProgress.configure({
  easing: 'ease', // 动画方式
  speed: 1000, // 递增进度条的速度
  showSpinner: false, // 是否显示加载ico
  trickleSpeed: 200, // 自动递增间隔
  minimum: 0.3 // 初始化时的最小百分比
})

export function toSSOLogin() {
  window.location.href = `/login`
}

export async function mixinPermission(router: any, options: any = {}) {
  const whiteList = defaultOptions.whiteList.concat(options.whiteList)
  router.beforeEach(async (to: ITo, _from: IFrom, next: (arg0?: any) => void) => {
    // start progress bar
    NProgress.start()

    // 白名单，直接放行
    if (whiteList.indexOf(to.path) !== -1) {
      return next()
    }

    const token = getToken()

    if (!token) {
      // 无token跳转到sso登录
      return toSSOLogin()
    }

    if (!router.hasRoute(to.name)) {
      return next({ path: '/404', replace: true })
    }

    // 获取用户store  获取个人信息
    const userStore = useUserStore()
    await userStore.actionUserInfo()

    next()
  })

  router.afterEach(() => {
    NProgress.done()
  })
}
